import { forwardRef } from "react";
import { cn } from "../../lib/utils";

/**
 * Plain native <select>, styled to match the design system. The full Radix Select is available
 * as a dependency for later, richer pickers, but a native select keeps mobile-first forms simple
 * and accessible for the MVP calculators.
 */
const SelectNative = forwardRef(({ className, children, ...props }, ref) => (
  <select
    ref={ref}
    className={cn(
      "flex h-10 w-full rounded-md border border-border bg-elevated px-3 py-2 text-sm text-text",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold",
      className
    )}
    {...props}
  >
    {children}
  </select>
));
SelectNative.displayName = "SelectNative";

export { SelectNative };
